import { plainToInstanceWithLVS } from '@goparrot/common';
import { AbstractStoreFacade } from '../../common';
import { ReadStoreDto, StoreExposeGroup } from '../../store';
export class StoreByMerchantFacade extends AbstractStoreFacade {
    constructor() {
        super(...arguments);
        this.baseUrl = '/api/v2/merchants';
    }
    async importLocations(merchantId, externalMerchantId, locations) {
        await this.client.post(`${this.baseUrl}/${merchantId}/stores/import/${externalMerchantId}`, locations);
    }
    async list(merchantId, filters) {
        const configs = {};
        if (filters) {
            configs.params = { ...filters };
        }
        return plainToInstanceWithLVS(ReadStoreDto, (await this.client.get(`${this.baseUrl}/${merchantId}/stores`, configs)).data, {
            groups: [StoreExposeGroup.READ],
        });
    }
    async listStoresIdsByMerchant(merchantId) {
        return (await this.client.get(`${this.baseUrl}/${merchantId}/stores/ids`)).data;
    }
    async get(merchantId, storeId) {
        return plainToInstanceWithLVS(ReadStoreDto, (await this.client.get(`${this.baseUrl}/${merchantId}/stores/${storeId}`)).data, {
            groups: [StoreExposeGroup.READ],
        });
    }
    async create(merchantId, data) {
        return plainToInstanceWithLVS(ReadStoreDto, (await this.client.post(`${this.baseUrl}/${merchantId}/stores`, data)).data, {
            groups: [StoreExposeGroup.READ],
        });
    }
    async update(merchantId, storeId, data) {
        return plainToInstanceWithLVS(ReadStoreDto, (await this.client.put(`${this.baseUrl}/${merchantId}/stores/${storeId}`, data)).data, {
            groups: [StoreExposeGroup.READ],
        });
    }
    async patch(merchantId, storeId, data) {
        return plainToInstanceWithLVS(ReadStoreDto, (await this.client.patch(`${this.baseUrl}/${merchantId}/stores/${storeId}`, data)).data, {
            groups: [StoreExposeGroup.READ],
        });
    }
    async delete(merchantId, storeId) {
        await this.client.delete(`${this.baseUrl}/${merchantId}/stores/${storeId}`);
    }
}
//# sourceMappingURL=StoreByMerchantFacade.js.map